var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSidebarSearchCompanies(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    stroke: "white",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9815 30.5525C23.7815 30.5525 30.1114 24.2225 30.1114 16.4225C30.1114 8.62248 23.7815 2.29248 15.9815 2.29248C8.18153 2.29248 1.85156 8.62248 1.85156 16.4225C1.85156 24.2225 8.18153 30.5525 15.9815 30.5525Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4772 32.9679L25.1172 26.6079",
    strokeWidth: 4.49999,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4765 32.9678L28.1016 29.5928",
    strokeWidth: 4.49999,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0962 9.56787H7.98624C7.18267 9.56787 6.53125 10.2193 6.53125 11.0229V11.0829C6.53125 11.8864 7.18267 12.5379 7.98624 12.5379H24.0962C24.8997 12.5379 25.5512 11.8864 25.5512 11.0829V11.0229C25.5512 10.2193 24.8997 9.56787 24.0962 9.56787Z",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8722 27.7026V12.5376H8.19727V27.7026",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6018 29.9079V25.3779H11.4668V29.9079",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M16.041 25.5728V31.0928",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "square",
    d: "M13.4461 15.6729H11.1211V17.8029H13.4461V15.6729Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "square",
    d: "M13.4461 20.3228H11.1211V22.4528H13.4461V20.3228Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "square",
    d: "M17.3465 15.6729H15.0215V17.8029H17.3465V15.6729Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "square",
    d: "M17.3465 20.3228H15.0215V22.4528H17.3465V20.3228Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "square",
    d: "M21.2469 15.6729H18.9219V17.8029H21.2469V15.6729Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "square",
    d: "M21.2469 20.3228H18.9219V22.4528H21.2469V20.3228Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarSearchCompanies);
export default __webpack_public_path__ + "static/media/sidebar-search-companies.5b0c45223d5fa52aa7e893e7b8cf3ccb.svg";
export { ForwardRef as ReactComponent };